import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { createHotelBooking, saveBooking } from '../../../services/bookingService';

const HotelCard = ({ hotel, onShowAlternatives, tripDetails }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [bookingAdded, setBookingAdded] = useState(false);

  const handleAddToBooking = () => {
    setIsAdding(true);
    try {
      const booking = createHotelBooking(hotel, tripDetails);
      const result = saveBooking(booking);
      
      if (result?.success) {
        setBookingAdded(true);
        setTimeout(() => setBookingAdded(false), 3000);
      }
    } catch (error) {
      console.error('Error adding to booking:', error);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="bg-background rounded-xl border border-border p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h4 className="text-lg font-semibold text-foreground mb-1">{hotel?.name}</h4>
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-1 bg-[#2E8B8B]/10 text-[#2E8B8B] text-xs font-medium rounded">
              {hotel?.category}
            </span>
            <div className="flex items-center gap-1">
              <Icon name="Star" size={14} className="text-yellow-500 fill-yellow-500" />
              <span className="text-sm font-medium text-foreground">{hotel?.rating}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-3 mb-4">
        <div className="flex items-start gap-2">
          <Icon name="MapPin" size={16} className="text-muted-foreground mt-0.5" />
          <p className="text-sm text-muted-foreground">{hotel?.location}</p>
        </div>
        <p className="text-sm text-muted-foreground">{hotel?.description}</p>
        
        <div className="flex flex-wrap gap-2">
          {hotel?.amenities?.slice(0, 4)?.map((amenity, index) => (
            <span key={index} className="px-2 py-1 bg-muted text-xs rounded">
              {amenity}
            </span>
          ))}
        </div>
      </div>

      <div className="border-t border-border pt-4 flex items-center justify-between">
        <div>
          <p className="text-xs text-muted-foreground">Total Cost</p>
          <p className="text-xl font-bold text-foreground">
            ₱{hotel?.totalCost?.toLocaleString()}
          </p>
          <p className="text-xs text-muted-foreground">
            ₱{hotel?.pricePerNight?.toLocaleString()} per night
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="RefreshCw"
            onClick={onShowAlternatives}
          >
            Alternatives
          </Button>
          <Button
            variant={bookingAdded ? "success" : "default"}
            size="sm"
            iconName={bookingAdded ? "Check" : "Plus"}
            onClick={handleAddToBooking}
            disabled={isAdding || bookingAdded}
            loading={isAdding}
          >
            {bookingAdded ? 'Added' : 'Add to Booking'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HotelCard;